module.exports = __webpack_public_path__ + "img/shipo-sales-plan-icon-excel.3e958bba.svg";